<template>
  <div class="template-container">
<!--    <transition>-->
      <router-view/>
<!--    </transition>-->
  </div>
</template>
<script type="text/babel">

export default {
  components: {},
  computed: {},
  watch: {},
  mounted() {
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.main-content {
  padding: 5px !important;
}
</style>
<style>
body {
  background-color: #dedede;
}
</style>
